"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OwsOptionsFeatureType_1 = require("./schema/OwsOptionsFeatureType");
var OwsOptionsStore_1 = require("./schema/OwsOptionsStore");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('owsOptionsStore', {
    options: (_a = {},
        /**
         * Initial values for options in the store should be "fail-safe" values in the
         *  event that the service call to fetch the options has not yet completed or failed.
         *
         * For example, while the default setting for a feature for a user that has made no
         * changes to the options may be to have it enabled, to increase coverage and
         * discoverability, we don't want to aggravate users by potentially having it
         * enabled after they explicitly disabled it.
         */
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.SmartSuggestions] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.SmartSuggestions,
            smartSuggestionsEnabled: false,
            browserLocationEnabled: false,
        },
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.DiverseEmojis] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.DiverseEmojis,
            diverseEmojisSelectedSkinTone: '',
        },
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.SurfaceActions] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.SurfaceActions,
            readSurfaceActions: ['Reply', 'ReplyAll', 'Forward'],
            readSurfaceAddins: [],
            composeSurfaceActions: ['AddAttachment', 'AddInlineImage', 'AddEmoji', 'ToggleRibbon'],
            composeSurfaceAddins: [],
        },
        _a[OwsOptionsFeatureType_1.OwsOptionsFeatureType.SkypeNotifications] = {
            feature: OwsOptionsFeatureType_1.OwsOptionsFeatureType.SkypeNotifications,
            skypeMessageNotification: 1,
            skypeCallingNotification: 1,
        },
        _a),
    loadState: OwsOptionsStore_1.LoadState.OptionsNotLoaded,
})();
var _a;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-outlook-service-options/lib/store/store.js
// module id = 2122
// module chunks = 2 3 4 39 49 108